module.exports = __webpack_public_path__ + "static/Collection_System_s-2cb855a9aee6d676ddef5e6f79024ebe.png";